
(function(){
  const KEY='airaa_recently_viewed_v19';
  const get=()=>{try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}};
  const save=a=>localStorage.setItem(KEY,JSON.stringify(a.slice(0,8)));
  const esc=s=>String(s||'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
  function render(){
    const wrap=document.querySelector('[data-airaa-recently-viewed]');
    const grid=document.querySelector('[data-airaa-recent-grid]');
    if(!wrap||!grid)return;
    const items=get();
    if(!items.length){wrap.hidden=true;return}
    wrap.hidden=false;
    grid.innerHTML=items.map(p=>`<a class="airaa-recent-card" href="${esc(p.url)}"><img loading="lazy" src="${esc(p.image)}" alt="${esc(p.title)}"><span>${esc(p.title)}</span><b>${esc(p.price)}</b></a>`).join('');
  }
  function track(){
    const root=document.querySelector('[data-product-handle]');
    if(!root)return;
    const p={handle:root.dataset.productHandle,title:root.dataset.productTitle,url:root.dataset.productUrl,image:root.dataset.productImage,price:root.dataset.productPrice};
    if(!p.handle)return;
    const arr=get().filter(x=>x.handle!==p.handle);
    arr.unshift(p);save(arr);render();
  }
  document.addEventListener('DOMContentLoaded',function(){
    track();render();
    const clear=document.querySelector('[data-airaa-clear-recent]');
    if(clear)clear.addEventListener('click',function(){localStorage.removeItem(KEY);render()});
  });
})();
